import type { FaireProductEntity } from "../../entity_types/product";

export const p_8p38rbyj4t: FaireProductEntity = {
  token: "p_8p38rbyj4t",
  type: "product",
  name: "PINK PEPPERCORN",
  brandToken: "b_a816kjydgp",
  brandName: "Casa Bosques",
  imageUrl: "https://cdn.faire.com/fastly/caf7209f6d2ccd2a0788d0e7d01c881a2ef681b83dade8fbc52a58c43b34b126.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6741e14dfce62955dbd03a867ce7c29e44b3841812621df651608771b9103a5a.jpeg"
  ],
  priceDollars: 8.5,
  description: "When dried, the rosy pink peppercorn berry becomes an extraordinary spice, prized for its delicate, almost citric flavor. Blended with our heirloom cacao, the smoky undertones and back notes, resembling Angelica and Juniper, are fragrant in the mouth, presenting a warm, citrus-pine flavor.\n\nIngredients: Organic cacao bean, Pink Peppercorn, organic cane sugar.\nNet Weight 60g (2.12oz)",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:56.184Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
